import Api from '../../../../shared/Api';

class MatterportLinkApi {
    static setMatterportLink(id: number, link: string): Promise<string> {
        return new Api().put(`/views/orders/${id}/matterport?link=${link}`, {});
    }

    static getMatterportLink(id: number) {
        return new Api().get(`/views/orders/${id}`);
    }

    static deleteMatterportLink(id: number) {
        return new Api().delete(`/views/orders/${id}/matterport`);
    }
    static sendMatterportLinks(orderId: number, brokerAgentEmail: string, url: string): Promise<void> {
        return new Api().post(`/views/orders/${orderId}/matterport/send-link`, {
            email: brokerAgentEmail,
            matterportLink: url
        });
    }
}

export default MatterportLinkApi;
